import React from 'react';
import { Link } from 'react-router-dom';
import { LuArrowRight } from "react-icons/lu";
import GMBanner from '../../../assets/GMBanner.png';
import './GenelMerkezBanner.css';

const GenelMerkezKatılBanner = () => {
  return (
    <div className='corporate-banner-container'>
        <div className='corporate-banner-desc'>
            <h1 className='corporate-banner-title'>Geleceği Birlikte İnşa Edelim</h1>
            <p className='corporate-banner-text'>
              ÖNDER çatısı altında yeteneklerinizi değere dönüştürün. Yenilikçi projeler, güçlü takım kültürü ve dinamik kariyer fırsatlarıyla ekibimizin bir parçası olun.
            </p>
            {/* Buton ve Resmin Mobilde Kenetlenmesi İçin Yeni Kapsayıcı Alan */}
            <div className="corporate-banner-action-area">
                <Link className='corporate-banner-link' to="/hakkımızda">
                  <span>Hakkımızda</span>
                  <LuArrowRight className='corporate-banner-arrow' />
                </Link>
                <div className='corporate-banner-image-wrapper'>
                    <img src={GMBanner} alt="Önder Kariyer Sandalyeler" />
                </div>
            </div>
        </div>
    </div>
  );
};

export default GenelMerkezKatılBanner;